import { IApiBaseErrorResponse } from '@app/api/interfaces/api-base-error-response.interface';
import { IComment } from '@app/api/interfaces/comment.interface';
import { IFpCorrelationData } from '@app/main/leak-detection/floating-popups/floating-popup-correlation/interfaces/fp-correlation-data';

export enum FpCorrelationCommentsActionType {
  GetData = 'GetData',
  GetDataSuccesses = 'GetDataSuccesses',
  UpdateComment = 'UpdateComment',
  UpdateCommentSuccess = 'UpdateCommentSuccess',
  UpdateCommentError = 'UpdateCommentError',
}

export interface FpCorrelationCommentsActionGetData {
  type: FpCorrelationCommentsActionType.GetData;
  date: string | null;
  popupMainData: IFpCorrelationData | null;
}

export interface FpCorrelationCommentsActionGetDataSuccesses {
  type: FpCorrelationCommentsActionType.GetDataSuccesses;
  date: string | null;
  data: IFpCorrelationData | null;
}

export interface FpCorrelationCommentsActionUpdateComment {
  type: FpCorrelationCommentsActionType.UpdateComment;
  content: string;
}

export interface FpCorrelationCommentsActionUpdateCommentSuccess {
  type: FpCorrelationCommentsActionType.UpdateCommentSuccess;
  comment: IComment;
}

export interface FpCorrelationCommentsActionUpdateCommentError {
  type: FpCorrelationCommentsActionType.UpdateCommentError;
  error: IApiBaseErrorResponse;
}

export type FpCorrelationCommentsActions =
  | FpCorrelationCommentsActionGetData
  | FpCorrelationCommentsActionGetDataSuccesses
  | FpCorrelationCommentsActionUpdateComment
  | FpCorrelationCommentsActionUpdateCommentSuccess
  | FpCorrelationCommentsActionUpdateCommentError;
